/**
 * Class joiner. Deliberately tiny — no `clsx`/`tailwind-merge` dependency, so
 * conflicting utilities must be avoided at the call site rather than merged away.
 */
export function cn(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ')
}
